import { render, staticRenderFns } from "./educationList.vue?vue&type=template&id=38bb0ec1&scoped=true"
import script from "./educationList.vue?vue&type=script&lang=js"
export * from "./educationList.vue?vue&type=script&lang=js"
import style0 from "./educationList.vue?vue&type=style&index=0&id=38bb0ec1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bb0ec1",
  null
  
)

export default component.exports